module.exports = __webpack_public_path__ + "img/deer-bike.40a8807f.jpg";